import React, {Component} from "react"

import Flex from "@irati/ui/src/Flex"
import {H2} from "@irati/ui/src/Typography"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import FormattedMessage from "@irati/utils/lang"

import {VIEW_TEAM} from "../../../routes/routeConfig"

class TeamEngagementHeader extends Component {
  render() {
    return (
      <Flex justifyContent="space-between">
        <H2>
          <FormattedMessage id="admin.components.teamEngagement.header.title" />
        </H2>
        <ButtonRouterLink primary to={VIEW_TEAM}>
          <FormattedMessage id="admin.components.teamEngagement.header.button" />
        </ButtonRouterLink>
      </Flex>
    )
  }
}

export default TeamEngagementHeader
